import {
  SELECT_EVENT,
  EVENT_FETCH,
  EVENT_FETCH_SUCCESS,
  EVENT_FETCH_FAIL,
  EVENTS_FETCH,
  EVENTS_FETCH_SUCCESS,
  EVENTS_FETCH_FAIL,
  LOGOUT
} from '../constants/ActionTypes';

const initialState = {
  eventID: null,
  name: null,
  venue: {},
  events: [],
  eventsById: {},
  eventsByPartnerID: {},
  loading: true,
  eventsLoading: true,
  errors: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SELECT_EVENT:
      return {
        ...state,
        ...action.event
      };
    case EVENT_FETCH:
      return {
        ...state,
        venue: {},
        loading: true
      }
    case EVENT_FETCH_SUCCESS:
        localStorage.setItem("organizationID", action.event.organizationID)
        return {
          ...state,
          loading: false,
          ...action.event
        }
    case EVENT_FETCH_FAIL:
        return {
          ...state,
          errors: action.error
        }
    case EVENTS_FETCH:
        return {
          ...state,
          eventsLoading: true,
        }
      case EVENTS_FETCH_SUCCESS:
          return {
            ...state,
            eventsLoading: false,
            events: action.events,
            eventsById: eventsById(action.events),
            eventsByPartnerID: eventsByPartnerID(action.events)
          }
      case EVENTS_FETCH_FAIL:
          return {
            ...state,
            eventsLoading: false,
            errors: action.error
          }
      case LOGOUT:
        return initialState;
    default:
      return state;
  }
}

function eventsByPartnerID(events) {
  return events.reduce((events, event) => {
    event.partners.forEach(partner => {
      events[partner.partnerID] = events[partner.partnerID] || [];
      events[partner.partnerID].push(event.eventID);
    })
    return events;
  }, {})
}

function eventsById(events) {
  return events.reduce((byId, event) => {
    byId[event.eventID] = event;
    return byId;
  }, {});
}